import type { UIMessage } from "ai";

export const salesAgentChatType = "sales_agent";
export const sessionsQueryKey = ["salesAgentChatSessions"];

export const salesAgentSuggestions = [
  "uiCommon:the-client-says-the-programme-is-too-expensive-how-should-i-respond",
  "uiCommon:help-me-plan-the-discovery-stage-of-the-call",
  "uiCommon:how-can-i-close-the-conversation-when-the-client-says-she-needs-to-think-a",
];

export {
  salesAgentModelOptions,
  defaultSalesAgentModelOptionId,
  isSalesAgentModelOptionId,
  getSalesAgentModelOption,
  type SalesAgentModelOptionId,
} from "@fitness-app/data-models/entities/SalesAgentConfig";
import {
  getSalesAgentModelOption,
  type SalesAgentModelOptionId,
} from "@fitness-app/data-models/entities/SalesAgentConfig";
import type { TFunction } from "i18next";

export const createSalesAgentSessionMetadata = (modelId: SalesAgentModelOptionId) => {
  const modelOption = getSalesAgentModelOption(modelId);

  return {
    model: {
      provider: modelOption.provider,
      optionId: modelOption.id,
      name: modelOption.model,
      label: modelOption.label,
      reasoningEffort: modelOption.reasoningEffort,
    },
  };
};

export const createSessionTitle = (tUi: TFunction, text: string) => {
  const firstLine = text.replace(/\s+/g, " ").trim();
  return firstLine.length > 56 ? `${firstLine.slice(0, 56)}...` : firstLine || tUi<string>("uiProducts:new-chat");
};

export const formatSessionDate = (tUi: TFunction, date: string | null | undefined): string => {
  if (!date) return "";
  const parsed = new Date(date);
  if (Number.isNaN(parsed.getTime())) return "";

  return new Intl.DateTimeFormat(tUi<string>("common:intlLocale"), {
    day: "2-digit",
    month: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  }).format(parsed);
};

export const emptyChatMessageParts: UIMessage["parts"] = [];
